export default {
    global: {
        black: '#000',
        white: '#fff',
    },
    primary: {
        blue: '#0D0B4D',
        cyan: '#39C5E5',
        green: '#42B277',
        orange: '#FF5502',
        pink: '#F4059D',
        purple: '#980BD9',
        red: '#D91241',
        redBright: '#FF004A',
        yellow: '#FFD102',
    },
    validation: {
        valid: '#28a745',
        invalid: '#dc3545',
    },
    grey: {
        light: '#ECEEF2',
        medium: '#D2D4DA',
        dark: '#A9ADB1',
        deep: '#333333',
    },
    boxShadow: {
        card: '0px 8px 24px -4px #0c0c0d14, 0px 6px 12px -6px #0c0c0d1f',
    },
};
